// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"5c3fe5dfea997bdb5bdd","293":"7dfc686da3898025810e"}[chunkId] + ".js";
};